import { jsx as _jsx } from "react/jsx-runtime";
import QRCode from "react-qr-code";
import styles from "./QR.module.scss";
const QR = ({ value, size = "md" }) => {
    return (_jsx("div", Object.assign({ className: styles.container }, { children: _jsx(QRCode, { size: 130, value: value, level: "H" }, void 0) }), void 0));
};
export default QR;
